import React from 'react';
import dynamic from 'next/dynamic';
import { StatusPhase } from '@/interfaces';
import { AccordionElement } from '../container-phase';
import { getStatusStep, getStep } from '@/lib';
import OptRequestForm from './OptRequestForm';
import { CaseContext } from '@/context/CaseContext';

const CaseInitiation = dynamic(
	() => import('./CaseInitiation').then((mod) => mod.CaseInitiation),
	{ ssr: false }
);

interface Props {
	casePhase: StatusPhase | undefined;
	// caseSteps: StepStatusCaseData | undefined;
	currentOpenStep: string[] | undefined;
	setCurrentOpenStep: React.Dispatch<
		React.SetStateAction<string[] | undefined>
	>;
}

export const ActiveCasePhase: React.FC<Props> = ({
	casePhase,
	// caseSteps,
	currentOpenStep,
	setCurrentOpenStep,
}) => {
	const { caseDetails } = React.useContext(CaseContext);

	const isComplaint = caseDetails?.case_type === 'CLASS_ACTION';

	const [isErrorMessage, setIsErrorMessage] = React.useState<boolean>(false);

	const optRequiredStep = getStep('Opt Out Request', casePhase?.steps);

	const caseInitiationStep = getStep(
		isComplaint ? 'Complaint' : 'Demand Letter',
		casePhase?.steps
	);

	return (
		<>
			<AccordionElement
				title="Case Initiation"
				step={isComplaint ? 'Complaint' : 'Demand Letter'}
				label={isComplaint ? 'Complaint' : 'Demand Letter'}
				id="1"
				phase={casePhase}
				statusStep={getStatusStep(
					isComplaint ? 'Complaint' : 'Demand Letter',
					casePhase?.steps
				)}
				setIsErrorMessage={setIsErrorMessage}
				isErrorMessage={isErrorMessage}
				currentOpenStep={currentOpenStep}
				setCurrentOpenStep={setCurrentOpenStep}
				stepCase={caseInitiationStep}
			>
				<CaseInitiation casePhase={casePhase} />
			</AccordionElement>
			<AccordionElement
				title="Opt Out Request (Optional)"
				label="Opt Out Request"
				id="2"
				phase={casePhase}
				statusStep={getStatusStep('Opt Out Request', casePhase?.steps)}
				setIsErrorMessage={setIsErrorMessage}
				isErrorMessage={isErrorMessage}
				currentOpenStep={currentOpenStep}
				setCurrentOpenStep={setCurrentOpenStep}
			>
				<OptRequestForm
					caseId={caseDetails?.id || ''}
					phaseId={casePhase?.fase_id || 0}
					stepCase={optRequiredStep}
				/>
			</AccordionElement>
		</>
	);
};

// import React from 'react';
// import dynamic from 'next/dynamic';
// import {
// 	CaseDetailsLawyer,
// 	StatusPhase,
// 	StepStatusCaseData,
// } from '@/interfaces';
// import { AccordionElement, ContainerPhase } from '../container-phase';
// import { getStatusPhase, getStatusStep, getStep } from '@/lib';
// import OptRequestForm from './OtpRequestForm';
// import { GET_CASE_DOCUMENTS } from '@/api';
// import { useQuery } from '@tanstack/react-query';
// import { caseApplicantService } from '@/api/caseApplicant';

// const DemandComplaint = dynamic(
// 	() => import('./DemandComplaint').then((mod) => mod.DemandComplaint),
// 	{ ssr: false }
// );

// interface Props {
// 	casePhase: StatusPhase | undefined;
// 	caseSteps: StepStatusCaseData | undefined;
// 	caseDetails: CaseDetailsLawyer | undefined;
// 	currentOpenStep: string | undefined;
// 	setCurrentOpenStep: React.Dispatch<React.SetStateAction<string | undefined>>;
// }

// export const ActiveCasePhase: React.FC<Props> = ({
// 	caseDetails,
// 	casePhase,
// 	caseSteps,
// 	currentOpenStep,
// 	setCurrentOpenStep,
// }) => {
// 	const [isErrorMessage, setIsErrorMessage] = React.useState<boolean>(false);
// 	const optRequiredStep = getStep('Opt Out Request', casePhase?.steps);
// 	const { data: caseDocuments } = useQuery({
// 		queryKey: [GET_CASE_DOCUMENTS, caseDetails],
// 		queryFn: () => caseApplicantService.getCaseDocuments(caseDetails?.id || ''),
// 		enabled: !!caseDetails?.id,
// 	});

// 	return (
// 		<ContainerPhase
// 			title="Active Case Phase"
// 			caseDetails={caseDetails}
// 			phaseSteps={casePhase?.steps}
// 			setIsErrorMessage={setIsErrorMessage}
// 			statusPhase={getStatusPhase({ steps: casePhase?.steps })}
// 			caseDocuments={caseDocuments?.data}
// 			phaseData={caseSteps?.status}
// 		>
// 			{casePhase?.steps.map((item) => (
// 				<React.Fragment key={'active-case-step-' + item.name}>
// 					{item.name === 'Demand Letter' || item.name === 'Complaint' ? (
// 						<AccordionElement
// 							label={item.name}
// 							phase={casePhase}
// 							statusStep={getStatusStep(item.name, casePhase?.steps)}
// 							setIsErrorMessage={setIsErrorMessage}
// 							isErrorMessage={isErrorMessage}
// 							currentOpenStep={currentOpenStep}
// 							setCurrentOpenStep={setCurrentOpenStep}
// 						>
// 							<DemandComplaint
// 								caseDetails={caseDetails}
// 								phaseId={casePhase?.fase_id || 0}
// 								step={item}
// 								type={
// 									item.name === 'Demand Letter' ? 'demand letter' : 'complaint'
// 								}
// 								switched={item.switched}
// 								caseDocuments={caseDocuments?.data}
// 							/>
// 						</AccordionElement>
// 					) : item.name === 'Opt Out Request' ? (
// 						<AccordionElement
// 							label="Opt Out Request"
// 							phase={casePhase}
// 							statusStep={getStatusStep('Opt Out Request', casePhase?.steps)}
// 							setIsErrorMessage={setIsErrorMessage}
// 							isErrorMessage={
// 								item.status !== 'default' ? isErrorMessage : undefined
// 							}
// 							currentOpenStep={currentOpenStep}
// 							setCurrentOpenStep={setCurrentOpenStep}
// 						>
// 							<OptRequestForm
// 								caseId={caseDetails?.id || ''}
// 								phaseId={casePhase?.fase_id || 0}
// 								stepCase={optRequiredStep}
// 								caseTitle={caseDetails?.title}
// 							/>
// 						</AccordionElement>
// 					) : null}
// 				</React.Fragment>
// 			))}
// 		</ContainerPhase>
// 	);
// };
